import { useCallback } from 'react';

export const useAgGridPagination = (TableOptionsDispatch) => {
    const setPageNum = useCallback((pageNum) => {
        TableOptionsDispatch({
            type: 'update',
            values: { PageNo: pageNum }
        });
    }, [TableOptionsDispatch]);

    const setRecordsPerPage = useCallback((recordsPerPage) => {
        TableOptionsDispatch({
            type: 'update',
            values: {
                PageNo: 1,
                RecordPerPage: recordsPerPage
            }
        });
    }, [TableOptionsDispatch]);

    return [
        setPageNum,
        setRecordsPerPage
    ];
};